<template>
    <div class="header-navigation">
        <app-common-menu :personal-menu="personalMenu"/>
        <app-personal-menu :personal-menu="personalMenu" :time="time"/>
    </div>
</template>

<script>
import {state} from "../../store";
import AppCommonMenu from "@/components/core/AppCommonMenu";
import AppPersonalMenu from "@/components/core/AppPersonalMenu";

const userMenu = [
    {
        label: "Мои торговые процедуры",
        name: "user-auctions-index",
    },
    {
        label: "Мой профиль",
        name: "profile.home",
    },
    {
        label: "Уведомления",
        name: "profile.messages",
        badge: "notReadMessagesCount"
    },
];
const operatorMenu = [
    {
        label: "Участники",
        name: "operator.users",
        badge: "notReadMessagesCount"
    },
    {
        label: "Шаблоны организаторов",
        name: "admin.organizers",
    },
    {
        label: "Организаторы",
        name: "admin.organizer-users",
        badge: 'notReadOrganizersMessagesCount',
    },
];
const operatorBuhgalterMenu = [
    ...operatorMenu,
    {
        label: "Оборотные средства",
        name: "operator-buhgalter.account-info",
        badge: 'WithdrawsCount',
    },
];
const organizerMenu = [
    {
        label: "Мои торговые процедуры",
        name: "organizer-auctions",
    },
    {
        label: "Мой профиль",
        name: "profile.home",
    },
    {
        label: "Уведомления",
        name: "profile.messages",
        badge: "notReadMessagesCount"
    },
    {
        label: "Мои шаблоны",
        name: "templates.organizers",
    },
];
const adminMenu = [
    ...operatorMenu,
    {
        label: "Баннеры",
        name: "admin-banners",
    },
    {
        label: "Тарифы",
        name: "admin.tariffs",
    },
    {
        label: "О сайте",
        name: "admin-about",
        nowrap: true
    },
    {
        label: "Страница редактирования",
        name: "admin-info-index",
    },
    {
        label: "Оборотные средства",
        name: "admin.account-info",
        badge: 'WithdrawsCount',
    },
    {
        label: "Операторы",
        name: "operators.list",
    },
];

export default {
    name: "AppMenu",
    components: {AppPersonalMenu, AppCommonMenu},
    mixins: [userMenu],
    props: {
        time: {
            required: false
        }
    },
    computed: {
        siteInfo: () => state.siteInfo,
        personalMenu() {
            const role = this.$auth?.watch?.data?.role
            switch (role) {
                case "admin":
                    return adminMenu;
                case "operator":
                    return operatorMenu;
                case "operator-buhgalter":
                    return operatorBuhgalterMenu;
                case "user":
                    return userMenu;
                case "organizer":
                    return organizerMenu;
                default:
                    return [];
            }
        },
    },
};
</script>
